<template>
    <div class="avatar" :style="{
        width: width,
        height: height
    }">
        {{ displayFrontName }}
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'Avatar',
        props: {
            width: {
                type: String,
                default: '51.52px'
            },
            height: {
                type: String,
                default: '51.52px'
            }
        },
        computed: {
            ...mapGetters([
                'userInfo'
            ]),
            displayFrontName() {
                let name = ''
                for(var i in this.userInfo.displayName) {
                    if(name.length < 2) {
                        name += this.userInfo.displayName[i]
                    }
                }
                return name
            }
        }
    }
</script>

<style scoped>
.avatar {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-default-neutral);
    background-color: var(--color-background-neutral-default);
    font-size: 14px;
	letter-spacing: 0.64px;
}
</style>